import { render, staticRenderFns } from "./PsvChart.vue?vue&type=template&id=6cd6350d&"
import script from "./PsvChart.vue?vue&type=script&lang=js&"
export * from "./PsvChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports